import { pcQwertyUS } from './pc-qwerty-us';
import { macQwertyGB } from './mac-qwerty-gb';

export const layouts = {
  PC: {
    US: {
      QWERTY: pcQwertyUS
    }
  },
  Mac: {
    GB: {
      QWERTY: macQwertyGB
    }
  }
};

export const getAvailablePlatforms = () => Object.keys(layouts);

export const getAvailableRegions = (platform) =>
  platform ? Object.keys(layouts[platform] || {}) : [];

export const getAvailableTypes = (platform, region) =>
  (platform && region) ? Object.keys(layouts[platform][region] || {}) : [];

export const getLayout = (platform, region, type) => {
  try {
    return layouts[platform][region][type];
  } catch (e) {
    return layouts.PC.US.QWERTY; // Default fallback
  }
};
